import { CountryEntry } from './CountryEntry';
import { OperatingChainContext } from '@spa/lib/react/context/OperatingChainContext';
import { countriesDe } from './countriesDe';
import { countriesEn } from './countriesEn';
import { countriesEs } from './countriesEs';
import { useContext } from 'react';
const useCountries = () => {
  let entries;
  const operatingChain = useContext(OperatingChainContext);
  bb0: switch (operatingChain) {
    case "B2C_AT_Store":
    case "B2C_CH_Store":
    case "B2C_DE_Store":
      {
        entries = countriesDe;
        break bb0;
      }
    case "B2C_ES_Store":
      {
        entries = countriesEs;
        break bb0;
      }
    default:
      {
        entries = countriesEn;
      }
  }
  return entries;
};
export default useCountries;